import { useState, useEffect } from 'react'
import axios from 'axios'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Spinner, Center } from '@chakra-ui/react'
import Login from './components/Login'
import WatchList from './components/WatchList'
import Positions from './components/Positions'
import { Toaster } from './components/ui/toaster'
import StopLossMonitors from './components/StopLossMonitors'
import Trades from './components/Trades'
import DashboardShell from './components/layout/DashboardShell'

// 设置 axios 默认配置
axios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL;

// 添加响应拦截器处理 token 过期
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      delete axios.defaults.headers.common['Authorization'];
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          await axios.post('/verify-token');
          setIsAuthenticated(true);
        } catch (error) {
          localStorage.removeItem('token');
          delete axios.defaults.headers.common['Authorization'];
          setIsAuthenticated(false);
        }
      }
      setIsLoading(false);
    };

    initAuth();
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const PrivateRoute = ({ children }) => {
    if (isLoading) {
      return (
        <Center h="100vh">
          <Spinner size="xl" color="brand.500" />
        </Center>
      );
    }
    return isAuthenticated ? children : <Navigate to="/login" />;
  };

  return (
    <>
      <Toaster />
      <Router>
        <Routes>
          <Route path="/login" element={<Login onLoginSuccess={handleLogin} />} />
          <Route
            element={
              <PrivateRoute>
                <DashboardShell />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="watchlist" replace />} />
            <Route path="watchlist" element={<WatchList />} />
            <Route path="positions" element={<Positions />} />
            <Route path="trades" element={<Trades />} />
            <Route path="stop-loss-monitors" element={<StopLossMonitors />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
